import React from 'react';
import { TrendingUp, TrendingDown, DollarSign, Fuel, Users, Building2 } from 'lucide-react';
import { Card } from '../ui/Card';
import { Property } from '../../hooks/useProperties';

interface MetricsOverviewProps {
  property: Property | null;
}

interface Metric {
  label: string;
  value: string | number;
  change: number;
  icon: React.ReactNode;
}

export default function MetricsOverview({ property }: MetricsOverviewProps) {
  const metrics: Metric[] = [
    {
      label: 'Property Value',
      value: property ? property.price : 'N/A',
      change: 0,
      icon: <DollarSign className="w-6 h-6" />
    },
    {
      label: 'Monthly Fuel Volume',
      value: property ? `${(property.fuelVolume / 1000).toFixed(1)}K gal` : 'N/A',
      change: 0,
      icon: <Fuel className="w-6 h-6" />
    },
    {
      label: 'C-Store Sales',
      value: property ? `$${(property.cstoreSales / 1000).toFixed(1)}K` : 'N/A',
      change: 0,
      icon: <Building2 className="w-6 h-6" />
    },
    {
      label: 'Profits',
      value: property ? `$${(property.profits / 1000).toFixed(1)}K` : 'N/A',
      change: 0,
      icon: <Users className="w-6 h-6" />
    }
  ];

  return (
    <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
      {metrics.map((metric) => (
        <Card key={metric.label} className="p-4">
          <div className="flex items-center gap-3 mb-4">
            <div className="p-2 bg-blue-50 text-blue-600 rounded-lg">
              {metric.icon}
            </div>
            <span className="text-sm text-gray-600">{metric.label}</span>
          </div>
          
          <div className="flex items-end justify-between">
            <span className="text-2xl font-bold">{metric.value}</span>
            {metric.change !== 0 && (
              <div className={`flex items-center gap-1 text-sm ${
                metric.change >= 0 ? 'text-green-600' : 'text-red-600'
              }`}>
                {metric.change >= 0 ? (
                  <TrendingUp className="w-4 h-4" />
                ) : (
                  <TrendingDown className="w-4 h-4" />
                )}
                {Math.abs(metric.change)}%
              </div>
            )}
          </div>
        </Card>
      ))}
    </div>
  );
}